// import { useStore } from "@/state/useState";
import { Settings } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
// import TicketBuddyLogo from "@/components/assets/TicketBuddyLogo";
import CloudNationLogo from "@/components/assets/CloudNationLogo";

export default function Header() {
  // const config = useStore((state) => state.config);

  return (
    <header className="sticky top-0 z-10 flex h-[57px] items-center gap-1 border-b bg-background px-4">   
  
      <div>
          <CloudNationLogo />
      </div>

      {/* {config?.ticketbuddy_logo ? (
        <div>
          <TicketBuddyLogo />
        </div>
      ) : (
        <h1 className="text-xl font-semibold">{config?.ai.name}</h1>
      )} */}
      <Drawer>
        <DrawerTrigger asChild>
          <Button variant="ghost" size="icon" className="md:hidden">
            <Settings className="size-4" />
            <span className="sr-only">Instellingen</span>
          </Button>
        </DrawerTrigger>
        <DrawerContent className="max-h-[80vh]">
          <DrawerHeader>
            <DrawerTitle>Configuratie</DrawerTitle>
            <DrawerDescription>
              Configureer de instellingen voor het model en de berichten.
            </DrawerDescription>
          </DrawerHeader>
        </DrawerContent>
      </Drawer>
    </header>
  );
}
